import type { QueryResult } from '@apollo/react-hooks';
import { gql, useQuery } from '@apollo/react-hooks';
import { getAssetPlanDashboardStats } from '#/graphql/queries';
import { AssetPlanDashboardStatsInput, GetAssetPlanDashboardStatsQuery } from '#/graphql/types';

const q = gql(getAssetPlanDashboardStats);

const useAssetPlanDashboardStatsQuery = (
  stats: AssetPlanDashboardStatsInput,
  assetPlanId: string,
  scenarioId: string,
  options?: { skip?: boolean },
): QueryResult<GetAssetPlanDashboardStatsQuery> => {
  const query: QueryResult<GetAssetPlanDashboardStatsQuery> = useQuery(q, {
    variables: { assetPlanId, scenarioId, stats },
    skip: options?.skip,
  });

  return {
    ...query,
    data: {
      ...query.data,
      getAssetPlanDashboardStats: query.data?.getAssetPlanDashboardStats ?? {},
    },
  } as QueryResult<GetAssetPlanDashboardStatsQuery>;
};

export default useAssetPlanDashboardStatsQuery;
